import { useState, useEffect } from "react"
import { Link } from "react-scroll"
import { useNavigate } from "react-router-dom"
import { v4 as uuidv4 } from "uuid"
import axiosWithAuth from "../../utils/axiosWithAuth"

import "../../styles/OrderDining.css"

import { diningData } from "../../data/diningData"
import cart_icon from "../../images/cart_icon.png"

import Banner from "../navigation/Banner"
import NavBarOrder from "../navigation/NavBarOrder"
import OrderDiningItem from "./OrderDiningItem"
import OrderDiningItemSub from "./OrderDiningItemSub"
import Modal from "../forms/Modal"
import CartModal from "../navigation/CartModal"
import Footer from "../navigation/Footer"
import WarnModal from "../navigation/WarnModal"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const initialCurrentItem = {
  show: false,
  id: "",
  name: "",
  price: [],
  quantity: null,
  note: [],
  extra: [],
  unit: [],
  unitList: [],
  addition: {},
  spread: {},
  sauce: {},
  dressing: {}
}

const initialCartItem = {
  id: "",
  name: "",
  price: 0.00,
  total: 0.00,
  servings: 1,
  quantity: 0,
  size: "",
  unit: "",
  unitList: "",
  detail: "",
  toppings: {},
  extras: {},
  additions: {},
  spreads: {},
  sauces: {},
  dressings: {},
  pic: ""
}

const initialCart = []

const checkHoursOfOp = () => {
  let date = new Date()

  let day = date.getDay()
  let time = date.getHours()

  if (day > 0 && time > 8 && time < 18) {
    return true
  } else if (day === 0 && time > 8 && time < 18)  {
    return true
  } else {
    return false
  }
}

function OrderDining({ user }) {
  // State
  const [ currentItem, setCurrentItem ] = useState(initialCurrentItem)
  const [ cartItem, setCartItem ] = useState(initialCartItem)
  const [ cart, setCart ] = useState(initialCart)
  const [ cartModal, setCartModal ] = useState(false)
  const [ edit, setEdit ] = useState(false)
  const [ warnModal, setWarnModal ] = useState(false)
  const [ welcome, setWelcome ] = useState(true)
  const [ warnNav, setWarnNav ] = useState("")
  const [ hoursOfOp, setHoursOfOp ] = useState(true)
  const [ oosid, setoosid ] = useState([])

  // Data
  const app = diningData.appetizers;
  const delSan = diningData.deliSandwiches;
  const hotSub = diningData.hotSubs;
  const sal = diningData.specialtySalads;
  const cal = diningData.calzones;
  const din = diningData.dinners;
  const piz = diningData.pizzas;

  const navigate = useNavigate()
  const orderid = uuidv4()

  useEffect(() => {
    if (user === null || orderid === undefined) {
      navigate("/register")
    } else{
      if (welcome) {
        if (user.data.user.display_name) {
          return setWelcome(false)
        } else {
          return navigate("/register")
        }
      }
    }
  }, [navigate, user, orderid, welcome])

  useEffect (() => {
    let timeCheck = checkHoursOfOp()
    
    if (user && timeCheck) {
      toast(`Hello ${user.data.user.display_name}!`)
    } else if (user && !timeCheck) {
      toast(`Hello ${user.data.user.display_name}!`)
    } else {
      return navigate("/register")
    }

    return setHoursOfOp(timeCheck)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    axiosWithAuth().get("/stock/out-of-stock-id")
      .then(res => {
        let oosidList = res.data.map(item => { 
          return item.stock_id 
        })

        return setoosid(oosidList)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect (() => {
    const interval = setInterval(() => {
      let timeCheckRe = checkHoursOfOp()
      return setHoursOfOp(timeCheckRe)
    }, 10000)

    return () => clearInterval(interval)
  }, [ hoursOfOp ])

  return (
    <div className="order-dining-page-container" >
      <Banner user={user} />

      <div className="nav-tab-container">
        <NavBarOrder 
          cartModal={cartModal} 
          setCartModal={setCartModal} 
          setWarnNav={setWarnNav}
          setWarnModal={setWarnModal}
        />

        <div className="o-tabbar-container" >
          <div className="o-tabbar-link-container">
            <Link className="tabbar-link" to="o-apps" smooth={true} offset={-200}>Appetizers</Link>
            <Link className="tabbar-link" to="o-sandwiches" smooth={true} offset={-200}>Deli Sandwiches</Link>
            <Link className="tabbar-link" to="o-subs" smooth={true} offset={-200}>Hot Subs</Link>
            <Link className="tabbar-link" to="o-salads" smooth={true} offset={-200}>Salads</Link>
            <Link className="tabbar-link" to="o-calzones" smooth={true} offset={-200}>Calzones</Link>
            <Link className="tabbar-link" to="o-dinners" smooth={true} offset={-200}>Dinners</Link>
            <Link className="tabbar-link" to="o-pizzas" smooth={true} offset={-200}>Pizzas</Link>
          </div>

          {hoursOfOp ?
            <div className="cart-icon-container" onClick={() => setCartModal(!cartModal)}>
              <img className="cart-icon" src={cart_icon} alt="Cart icon" />
            </div>
          : null}
        </div>
      </div>
      
      <div className="order-dining-page-content-container">
        <div className="order-dining-content-1">
          <h1>Order Dining</h1>
        </div>

        <div className="order-dining-content-2">
          {hoursOfOp ?
            <>
              <div className="order-dining-section-header" id="o-apps">
                <span>Appetizers</span>
              </div>          
              <div className="order-dining-section-container">
                {app.map(item => (
                  item.name !== "Garlic Knots" ?
                    <OrderDiningItem dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} /> :
                    <OrderDiningItemSub dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-sandwiches">
                <span>Deli Sandwiches</span>
              </div>          
              <div className="order-dining-section-container">
                {delSan.map(item => (
                  <OrderDiningItem dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-subs">
                <span>Hot Subs</span>
              </div>          
              <div className="order-dining-section-container">
                {hotSub.map(item => (
                  <OrderDiningItemSub dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-salads">
                <span>Specialty Salads</span>
              </div>          
              <div className="order-dining-section-container">
                {sal.map(item => (
                  <OrderDiningItem dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-calzones">
                <span>Calzones</span><br/>
                <span className="subnote">*Served with pomodoro sauce</span>
              </div>          
              <div className="order-dining-section-container">
                {cal.map(item => (
                  <OrderDiningItem dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-dinners">
                <span>Dinners</span><br/>
              </div>          
              <div className="order-dining-section-container">
                {din.map(item => (
                  <OrderDiningItem dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>

              <div className="order-dining-section-header" id="o-pizzas">
                <span>Brick Oven Pizzas</span><br/>
                <span className="subnote">*Gluten free available</span><br/>
                <span className="subnote">*Half/Half pizza available, specify in details</span>
              </div>          
              <div className="order-dining-section-container">
                {piz.map(item => (
                  <OrderDiningItemSub dinItem={item} setCurrentItem={setCurrentItem} oosid={oosid} key={item.id} />
                ))}
              </div>
            </> : 
            <div className="HOO-closed">
              <span>Sorry, we're currently closed.</span>
              <span>-----</span>
              {/* <<<<<----- WIP: Catering Banquet ----->>>>>
              <span>We can still recieve Catering and Banquet requests and will get back to you as soon as possible.</span>
              <span>-----</span> */}
              <span>Please check our store hours on the Home page and come again tomorrow!</span>
            </div>
          }
        </div>

        <Footer />

      </div>
      
      <Modal 
        currentItem={currentItem}
        setCurrentItem={setCurrentItem}
        cartItem={cartItem}
        setCartItem={setCartItem}
        cart={cart}
        setCart={setCart}
        edit={edit}
        setEdit={setEdit}
        user={user}
        orderid={orderid}
        onClose={() => {
          setCurrentItem({...initialCurrentItem, show: false})
          setEdit(false)
        }} 
        hoursOfOp={hoursOfOp}
      />

      {cartModal ? 
        <CartModal 
          setCurrentItem={setCurrentItem}
          setCartItem={setCartItem}
          cart={cart} 
          setCart={setCart} 
          cartModal={cartModal}
          setCartModal={setCartModal}
          setEdit={setEdit}
          user={user}
          orderid={orderid}
          onClose={() => setCartModal(false)} 
          hoursOfOp={hoursOfOp}
        /> 
      : null }

      {warnModal ?
        <WarnModal 
          warnNav={warnNav} 
          onClose={() => setWarnModal(false)} 
        />
      : null}

    </div>
  )
}

export default OrderDining
